import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'
import type { FlashType } from 'modules/core/store/models/app'
import app from 'modules/core/store/models/app'

import type { Action } from '../../types'

interface Props {
  dispatch: React.Dispatch<Action>
  keyName: string
  token: string
}

const ReadModal = ({ dispatch, keyName, token }: Props) => {
  const showFlashMessage = (type: FlashType, message: string) => {
    app.setFlash({
      type,
      message,
    })
  }

  return (
    <Modal
      title={i18n.t('settings.api_keys.read.title')}
      description={i18n.t('settings.api_keys.read.description', { key_name: keyName })}
      illustration="network-group"
      onClose={() => dispatch({ type: 'closeModals' })}
      footer={
        <Button type="primary" onClick={() => dispatch({ type: 'closeModals' })}>
          {i18n.t('settings.api_keys.read.okay')}
        </Button>
      }
    >
      <FormRow>
        <TextField label="Key" placeholder={token ?? ''} readonly />
      </FormRow>
      <FormRow>
        <Button
          type="secondary"
          onClick={() => {
            navigator.clipboard.writeText(token ?? '')
            showFlashMessage('correct', i18n.t('settings.api_keys.read.copied'))
          }}
        >
          {i18n.t('settings.api_keys.read.copy_key')}
        </Button>
      </FormRow>
    </Modal>
  )
}

export default ReadModal
